// src/mutationOptions.ts
function mutationOptions(options) {
  return options;
}
export {
  mutationOptions
};
//# sourceMappingURL=mutationOptions.js.map